
import {Component, Vue} from 'vue-property-decorator'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import UserGroupTokenInfo from '@/model/modules/UserGroupTokenInfo'
import CompanyService from '@/service/modules/CompanyService'
import CompanyInfo from '@/model/modules/CompanyInfo'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import UserGroupTokenService from '@/service/modules/UserGroupTokenService'

@Component
export default class UserGroupTokenEditor extends Vue {
  item: UserGroupInfo = new UserGroupInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any
  companyList: CompanyInfo[] = []
  tokenData: { [index: string]: UserGroupTokenInfo } = {}
  dataLoadingState: boolean = false

  showEditor(item: UserGroupInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
    this.loadAllData()
  }

  loadAllData() {
    this.dataLoadingState = true
    CompanyService.list({}, 0, 99999)
      .then((result: BasePageableInfo<CompanyInfo>) => {
        this.companyList = result.dataList
        this.companyList.forEach((company: CompanyInfo) => {
          const tokenInfo = new UserGroupTokenInfo()
          tokenInfo.companyId = company.id
          tokenInfo.groupId = this.item.id
          this.tokenData[company.id] = tokenInfo
        })
        const example = {}
        //  @ts-ignore
        example.groupId = this.item.id
        UserGroupTokenService.list(example, 0, 999999)
          .then((tokenResult: BasePageableInfo<UserGroupTokenInfo>) => {
            tokenResult.dataList.forEach((token: UserGroupTokenInfo) => {
              this.tokenData[token.companyId] = token
            })
            this.dataLoadingState = false
          })
      })
  }

  saveEditor() {
    this.savingState = true
    for (const tokenDataKey in this.tokenData) {
      if (this.tokenData[tokenDataKey].id === 0) {
        delete this.tokenData[tokenDataKey].id
      }
      UserGroupTokenService.save(this.tokenData[tokenDataKey])
        .then(() => {
        })
    }
    this.$alert('保存数据', '保存成功', {
      confirmButtonText: '确定'
    })
    this.savingState = false
    this.showState = false
    this.saveSuccessCallback()
  }
}
